// THE SHARED VOCABULARY, German — the words every page speaks alike: the review verbs, the
// statuses, the tiers, the stages, the small words. Registered once from PageKit (which is in
// every bundle), so a page catalogue need not repeat them. Repeating one with the SAME value is
// harmless; a DIFFERENT value warns in the console and the first registration wins.
import { registerDe } from './index.js';

registerDe({
  // ── the review verbs (the vocabulary of P1) ──
  'Hold': 'Übernehmen',
  'Held': 'Übernommen',
  'held': 'übernommen',
  'Refuse': 'Ablehnen',
  'Refused': 'Abgelehnt',
  'refused': 'abgelehnt',
  'Amend': 'Anpassen',
  'Amended': 'Angepasst',
  'amended': 'angepasst',
  'Undo': 'Rückgängig',
  'Unheld': 'Nicht übernommen',
  'unheld': 'nicht übernommen',
  'Proposed': 'Vorgeschlagen',
  'proposed': 'vorgeschlagen',
  'Confirm': 'Bestätigen',
  'Confirmed': 'Bestätigt',
  'Retract': 'Zurückziehen',
  'Retracted': 'Zurückgezogen',
  'Discharge': 'Erledigen',
  'Discharged': 'Erledigt',
  'Drop': 'Verwerfen',
  'Dropped': 'Verworfen',
  'Archive': 'Archivieren',
  'Archived': 'Archiviert',

  // ── the everyday verbs ──
  'Save': 'Speichern',
  'Cancel': 'Abbrechen',
  'Close': 'Schliessen',
  'Delete': 'Löschen',
  'Edit': 'Bearbeiten',
  'Add': 'Hinzufügen',
  'New': 'Neu',
  'Remove': 'Entfernen',
  'Refresh': 'Aktualisieren',
  'Open': 'Öffnen',
  'Try again': 'Erneut versuchen',
  'Clear the filter': 'Filter aufheben',
  'Log out': 'Abmelden',
  'Loading…': 'Wird geladen…',
  'Saving…': 'Wird gespeichert…',

  // ── the refusal reasons ──
  'duplicate': 'Duplikat',
  'wrong_evidence': 'falscher Beleg',
  'stale': 'veraltet',
  'not_relevant': 'nicht relevant',
  'out_of_scope': 'ausserhalb des Umfangs',
  'other': 'anderes',

  // ── statuses on the record ──
  'active': 'aktiv',
  'dormant': 'ruhend',
  'archived': 'archiviert',
  'candidate': 'Kandidat',
  'current': 'aktuell',
  'superseded': 'abgelöst',
  'open': 'offen',
  'discharged': 'erledigt',

  // ── the pipeline stages ──
  'lead': 'Lead',
  'qualified': 'qualifiziert',
  'scoping': 'Scoping',
  'proposal': 'Offerte',
  'negotiation': 'Verhandlung',
  'contracting': 'Vertrag',
  'won': 'gewonnen',
  'lost': 'verloren',

  // ── the nav ──
  'Overview': 'Übersicht',
  'Network': 'Netzwerk',
  'Outreach': 'Ansprache',
  'System': 'System',

  // ── the small words ──
  'not collected': 'nicht erhoben',
  'nothing on record': 'nichts erfasst',
  'not set': 'nicht gesetzt',
  'not named': 'nicht benannt',
  'undated': 'ohne Datum',
  'none': 'keine',
  'Nothing was written.': 'Es wurde nichts geschrieben.',
  'Could not load': 'Konnte nicht geladen werden',
  'Nothing matches': 'Nichts passt',
  'Nothing here yet': 'Hier ist noch nichts',
  'Not built yet': 'Noch nicht gebaut',
  'us': 'wir',
  'them': 'sie',
  'late': 'überfällig',
  'due': 'fällig',
  'people': 'Personen',
  'person': 'Person',
  'organisation': 'Organisation',
  'organisations': 'Organisationen',
  'deals': 'Geschäfte',
  'Toggle theme': 'Darstellung wechseln',
  'Toggle sidebar': 'Seitenleiste umschalten',
  'Open menu': 'Menü öffnen',
  'Close menu': 'Menü schliessen',
}, 'common');
